import axios from "axios";
import { GURL } from "./global";

export const AddFilter = (f: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Authentication/v1/Filters`, f);
};

export const GetFiltersByUserIdAndRoute = (route: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Authentication/v1/Filters/GetByUserIdAndRoute?route=${route}`;
  return axios.get(url);
};

export const GetFilterDetailsByFilterId = (filterId: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Authentication/v1/FilterDetails/GetByFilterId?filterId=${filterId}`;
  return axios.get(url);
};
